module.exports = __webpack_public_path__ + "img/icon2.8f2b1306.png";